<template>
  <div>
    <b-table
      bordered
      hover
      class="col-md-12"
      :fields="fields"
      :items="items"
      :per-page="10"
      :current-page="currentPage"
      show-empty
    >
      <template #empty>
        <div class="text-center py-5">
          <i
            class="flaticon2-list text-muted"
            style="font-size: 3rem"
          ></i>
          <p class="text-muted mt-3 mb-0">
            Chưa có cấu hình chiết khấu cho
            {{ type === 'product' ? 'sản phẩm' : 'danh mục' }}
          </p>
        </div>
      </template>

      <template #cell(count)="row">
        {{ row.item.count }}
      </template>

      <template #cell(productName)="row">
        <div class="d-flex align-items-center">
          <ProductCommonInfo
            :product="row.item"
            v-if="row.item.productId"
          />
          <CompanyCodeBadge
            :company-code="row.item.companyCode"
            :company-name="row.item.companyName"
            class="ml-1"
          />
          <!-- <b-badge
            v-if="row.item.notAchieved"
            variant="warning"
            class="ml-2"
          >
            Chưa đạt
          </b-badge> -->
        </div>
      </template>
      <template #cell(imeiDetails)="row">
        <i
          class="flaticon-eye text-primary"
          @click="$emit('show-imei-modal', row.item)"
          role="button"
        ></i>
        <span></span>
      </template>

      <template #cell(categoryName)="row">
        <div class="d-flex align-items-center">
          <span v-if="row.item.categoryId">{{ row.item.categoryName }}</span>
          <CompanyCodeBadge
            :company-code="row.item.companyCode || mainModel.companyCode"
            :company-name="row.item.companyName || mainModel.companyName"
            class="ml-1"
          />
          <b-badge
            v-if="row.item.notAchieved"
            variant="warning"
            class="ml-2"
          >
            Chưa đạt
          </b-badge>
        </div>
      </template>
      <template #cell(discountPolicyType)="row">
        <b-dropdown
          :text="row.item.discountPolicyType"
          size="sm"
          variant="outline-primary"
        >
          <b-dropdown-item
            v-for="discountPolicyType in discountPolicyOptions"
            :key="discountPolicyType"
            @click="$emit('change-discount-policy-type', row.item, discountPolicyType)"
          >
            {{ discountPolicyType }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template v-slot:cell(targetQuantity)="row">
        <b-input-group>
          <template #prepend>
            <b-dropdown
              :text="row.item.targetType"
              size="sm"
              variant="outline-primary"
            >
              <b-dropdown-item
                v-for="targetType in availableTargetTypes"
                :key="targetType"
                @click="$emit('change-target-type', row.item, targetType)"
              >
                {{ targetType }}
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <b-form-input
            v-mask="mask"
            v-model="row.item.targetQuantity"
            placeholder="Nhập chỉ tiêu"
            class="form-control form-control-sm text-right"
          ></b-form-input>
        </b-input-group>
      </template>

      <template v-slot:cell(discountAmount)="row">
        <b-input-group>
          <template #prepend>
            <b-dropdown
              :text="
                row.item.discountType == AMOUNT_TYPE.MONEY
                  ? '$'
                  : row.item.discountType == AMOUNT_TYPE.PERCENT
                  ? '%'
                  : '%'
              "
              size="sm"
              variant="outline-primary"
            >
              <b-dropdown-item
                @click="$emit('change-discount-type', row.item, AMOUNT_TYPE.MONEY)"
                >{{ '$' }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="$emit('change-discount-type', row.item, AMOUNT_TYPE.PERCENT)"
                >{{ '%' }}</b-dropdown-item
              >
            </b-dropdown>
          </template>
          <b-form-input
            v-mask="mask"
            v-model="row.item.discountAmount"
            placeholder="Nhập mức hỗ trợ"
            class="form-control form-control-sm text-right"
          ></b-form-input>
        </b-input-group>
      </template>

      <template v-slot:cell(achieved)="row">
        <span
          :class="row.item.achievedRatio >= mainModel.targetMin ? 'text-success' : 'text-danger'"
        >
          {{ convertPrice(row.item.achieved) }}
        </span>
      </template>

      <template v-slot:cell(supportedAmount)="row">
        <span>
          {{ convertPrice(row.item.supportedAmount) }}
        </span>
      </template>

      <template v-slot:cell(achievedRatio)="row">
        <span
          v-if="row.item.achievedRatio !== undefined"
          :class="row.item.achievedRatio >= mainModel.targetMin ? 'text-success' : 'text-danger'"
        >
          {{ row.item.achievedRatio }}%
        </span>
      </template>

      <template v-slot:cell(actions)="row">
        <i
          class="flaticon2-rubbish-bin-delete-button text-danger"
          role="button"
          @click="$emit('delete-item', row.item, type === 'product' ? 'sản phẩm' : 'danh mục')"
        ></i>
      </template>
    </b-table>

    <b-row>
      <b-col>
        <p
          class="mt-3 text-dark"
          style="font-weight: 500"
        >
          Tổng số:
          {{ items.length }}
        </p>
      </b-col>
      <b-pagination
        class="custom-pagination"
        v-show="items.length > 10"
        v-model="localCurrentPage"
        :total-rows="items.length"
        :per-page="10"
        align="right"
      >
      </b-pagination>
    </b-row>
  </div>
</template>

<script>
import {
  AMOUNT_TYPE,
  TARGET_TYPE,
  DISCOUNT_POLICY_TYPE,
  DEAL_SHEET_TARGET_TYPE,
} from '@/utils/enum'
import { currencyMask, convertPrice } from '@/utils/common'
import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue'
import CompanyCodeBadge from '@/view/components/common/CompanyCodeBadge.vue'

export default {
  name: 'DealSheetDetailTable',
  components: {
    ProductCommonInfo,
    CompanyCodeBadge,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ['product', 'category'].includes(value),
    },
    mainModel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      AMOUNT_TYPE,
      TARGET_TYPE,
      DEAL_SHEET_TARGET_TYPE,
      mask: currencyMask,
      localCurrentPage: this.currentPage,
      discountPolicyOptions: Object.values(DISCOUNT_POLICY_TYPE),
    }
  },
  computed: {
    availableTargetTypes() {
      if (this.mainModel.targetType === this.DEAL_SHEET_TARGET_TYPE.SALE_OUT) {
        return Object.values(this.TARGET_TYPE)
      }
      return [this.TARGET_TYPE.QUANTITY]
    },
  },
  watch: {
    currentPage(newVal) {
      this.localCurrentPage = newVal
    },
    localCurrentPage(newVal) {
      this.$emit('update:currentPage', newVal)
    },
  },
  methods: {
    convertPrice,
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .table {
    th,
    td {
      padding: 0.75rem;
      vertical-align: middle;
      border-top: 1px solid #ecf0f3;
    }
  }
}
</style>